import { isFunction } from "lodash";
import { useMutation, useQueryClient } from "react-query";
import type { UpdateParams } from "@/react/api/mobileHomeSegmentsApi";
import { mobileHomeSegmentsApi } from "@/react/api/mobileHomeSegmentsApi";
import type { ApiError } from "@/react/config/CustomErrors";
import { useToast } from "@circle-react-uikit/ToastV2";
import { SHOW_QUERY_KEY } from "./useMobileAppSettings";

interface UseUpdateMobileHomeSegmentProps {
  onSuccess?: () => void;
}
export const useUpdateMobileHomeSegment = ({
  onSuccess,
}: UseUpdateMobileHomeSegmentProps) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const {
    mutate,
    mutateAsync,
    isLoading: isUpdating,
  } = useMutation<unknown, ApiError, UpdateParams>({
    mutationFn: mobileHomeSegmentsApi.update,
    onSuccess: () => {
      void queryClient.invalidateQueries(SHOW_QUERY_KEY);
      if (isFunction(onSuccess)) {
        onSuccess();
      }
    },
    onError: (error: { message: string }) => {
      toast.error(error.message);
    },
  });

  return { mutate, isUpdating, mutateAsync };
};
